import React from "react";
import BooksNavbar from "./BooksNavbar";
import BooksFooter from "./BooksFooter";

const BooksAbout = () => {
  return (
    <div>
      {/* HERO */}
      <section className="relative min-h-[90vh] bg-white overflow-hidden">
        <BooksNavbar textColor="black" />

        <div className="relative z-10 min-h-[90vh] flex items-center pt-28 pb-16">
          <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 items-center">
            
            {/* left image */}
            <div className="flex justify-center lg:justify-start order-2 lg:order-1">
              <img
                src="/about_the_author.jpeg"
                alt="Adrian Owen"
                className="w-full max-w-[520px]"
              />
            </div>

            {/* right text */}
            <div className="text-center lg:text-left order-1 lg:order-2">
              <p
                className="text-xs tracking-[0.35em] text-[#8c8b5f] mb-4 uppercase"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                About the Author
              </p>

              <h1
                className="text-5xl md:text-7xl text-black leading-tight mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Adrian Owen
              </h1>

              <div className="flex items-center w-full max-w-sm mb-8 mx-auto lg:mx-0">
                <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
                <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
                <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              </div>

              <p
                className="text-xl md:text-2xl italic text-[#5f6f4f] leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                A scientist, storyteller, musician, and explorer of the hidden
                systems that shape human thought.
              </p>

              <a
                href="https://wwnorton.com/books/9781324075165"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#D4AF37] text-black px-6 py-3 text-sm font-semibold tracking-widest"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                ORDER THE BOOK
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* MAIN BIOGRAPHY */}
      <section className="bg-[#f5f3ef] py-16">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <p
            className="text-xs tracking-[0.35em] text-[#D4AF37] mb-4 uppercase text-center"
            style={{ fontFamily: "Playfair Display, serif" }}
          >
            The Story Behind the Scientist
          </p>

          <h2
            className="text-3xl md:text-5xl text-black leading-tight text-center mb-8"
            style={{ fontFamily: "Playfair Display, serif" }}
          >
            From the psychology of thought to the mysteries of consciousness.
          </h2>

          <div className="flex items-center w-full max-w-sm mb-12 mx-auto">
            <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
            <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
          </div>

          <div className="columns-1 md:columns-2 gap-12">
            <p
              className="text-gray-700 leading-relaxed mb-6 break-inside-avoid"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              If you had met Adrian Owen as a child, you probably wouldn't have
              predicted a career spent investigating some of the deepest
              mysteries of the human brain. He was far more interested in
              theatre and making music than in becoming a scientist. Yet
              somewhere along the way he developed a fascination with a simple
              question: how does that three-pound lump of biological tissue
              inside our heads give rise to every thought, feeling, and memory
              we've ever had? That question has taken him on an extraordinary
              journey.
            </p>

            <p
              className="text-gray-700 leading-relaxed mb-6 break-inside-avoid"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Over the last four decades, Adrian has worked in some of the
              world's leading neuroscience laboratories, from Montreal, Canada
              and Cambridge, U.K., to his present home at Western University in
              London, Ontario. Along the way he has published more than 450
              scientific papers, become a Fellow of the Royal Society, received
              an OBE from Queen Elizabeth II for services to science, and helped
              establish entirely new ways of detecting consciousness in patients
              who appear unable to communicate.
            </p>

            <p
              className="text-gray-700 leading-relaxed mb-6 break-inside-avoid"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              His work has been featured in most of the world's top scientific
              journals, including <em>Science</em>, <em>Nature</em>,{" "}
              <em>The New England Journal of Medicine</em>, and{" "}
              <em>The Lancet</em>, as well as countless documentaries,
              newspapers, podcasts, and television programmes.
            </p>

            <p
              className="text-gray-700 leading-relaxed mb-6 break-inside-avoid"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Adrian is best known for his remarkable fMRI discovery made in
              2006 and published in the journal <em>Science</em>, showing that a
              young woman who had been diagnosed as being in a vegetative state
              could understand spoken instructions and intentionally alter her
              brain activity to answer questions. The finding challenged decades
              of assumptions about consciousness and transformed the way
              scientists and clinicians think about severe brain injury.
            </p>

            <p
              className="text-gray-700 leading-relaxed mb-6 break-inside-avoid"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              In <em>Think Before You Think</em>, Adrian draws on his years
              spent studying consciousness, coma, dementia, brain injury, memory,
              and cognition to tackle a much bigger question: what actually
              allows us to function successfully in everyday life? Why do some
              people make wise decisions while others repeatedly sabotage
              themselves? Why can one person remain calm in a crisis while
              another loses control? Why do intelligence and success so often
              fail to travel together?
            </p>

            <p
              className="text-gray-700 leading-relaxed mb-6 break-inside-avoid"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Today, Adrian is Professor of Cognitive Neuroscience and Imaging
              at Western University in Canada, where he continues to investigate
              how the brain supports thought, behaviour, and consciousness. When
              he isn't in the laboratory, writing books, or giving lectures
              around the world, he can often be found writing songs, playing
              guitar, arguing with artificial intelligence, or pondering why he
              ever agreed to jump out of a perfectly serviceable aircraft at
              10,000 feet.
            </p>
          </div>

          <p
            className="text-2xl md:text-3xl italic text-[#5f6f4f] leading-relaxed text-center mt-12"
            style={{ fontFamily: "Playfair Display, serif" }}
          >
            As you'll discover throughout this book, the most fascinating thing
            about the brain isn't how much it knows. It's how it decides what to
            do next.
          </p>
        </div>
      </section>

      {/* THREE FEATURE BLOCKS */}
      <section className="bg-[#f5f3ef] py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white p-8 text-center">
              <p
                className="text-xs tracking-[0.3em] text-[#D4AF37] mb-4 uppercase"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Science
              </p>

              <h3
                className="text-2xl text-black mb-4"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Consciousness and the brain
              </h3>

              <p
                className="text-gray-700 leading-relaxed"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Adrian's work has transformed how scientists and clinicians
                think about consciousness, severe brain injury, and the hidden
                activity of the human mind.
              </p>
            </div>

            <div className="bg-white p-8 text-center">
              <p
                className="text-xs tracking-[0.3em] text-[#D4AF37] mb-4 uppercase"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                The Book
              </p>

              <h3
                className="text-2xl text-black mb-4"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Executive function in everyday life
              </h3>

              <p
                className="text-gray-700 leading-relaxed"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                <em>Think Before You Think</em> explores the mental systems that
                help us plan, focus, remember, adapt, regulate emotions, and
                make better decisions.
              </p>
            </div>

            <div className="bg-white p-8 text-center">
              <p
                className="text-xs tracking-[0.3em] text-[#D4AF37] mb-4 uppercase"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Beyond the Lab
              </p>

              <h3
                className="text-2xl text-black mb-4"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Music, stories, and curiosity
              </h3>

              <p
                className="text-gray-700 leading-relaxed"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Away from the lab, Adrian writes songs, plays guitar, gives
                lectures around the world, and keeps asking what makes human
                thought so strange and remarkable.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-white py-14">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="text-center md:text-left">
            <h2
              className="text-3xl md:text-4xl text-black mb-3"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Think before you think.
            </h2>

            <p
              className="text-gray-600"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Understand your executive function. Change your life.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="/books/science"
              className="border border-black text-black px-6 py-3 text-sm font-semibold tracking-widest text-center"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              EXPLORE THE SCIENCE
            </a>

            <a
              href="https://wwnorton.com/books/9781324075165"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#D4AF37] text-black px-6 py-3 text-sm font-semibold tracking-widest text-center"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              PREORDER
            </a>
          </div>
        </div>
      </section>

      <BooksFooter />
    </div>
  );
};

export default BooksAbout;